export const NAVER_CALL_URL = 'https://jjblab.co.kr/oauth2/authorization/naver';
export const KAKAO_CALL_URL = 'https://jjblab.co.kr/oauth2/authorization/kakao';
export const GOOGLE_CALL_URL = 'https://jjblab.co.kr/oauth2/authorization/google';
export const APPLE_CALL_URL = 'https://jjblab.co.kr/login/apple';
